/** Client entry. OWNER: integration. */
import './style.css';
import { App } from './game/app';

const root = document.getElementById('app')!;
const app = new App(root);
(window as unknown as { __game: unknown }).__game = app.debug;
app.start();
